import { selectOffer } from './index';
import { IState } from '../../store';

export const selectIsOfferPublished = (state: IState) => {
  const offer = selectOffer(state);

  return offer.status === 'published';
};
